import { SET_CLIENT_BRAND } from "../actions/types";

const initialState = {
  brand: {
    brandName: "",
    tokenMapBox: "",
    endpointToSupport: "",
    endpointToPrivacy: "",
    endpointToTermsAndConditions: "",
    icons: {
      principalIcon: "",
      favicon: "",
      logo: "",
      mapIcon: {},
      cards: {},
    },
    colors: {
      primaryColor: "",
      secondaryColor: "",
    },
  },
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CLIENT_BRAND:
      return {
        ...state,
        brand: action.payload,
      };
    default:
      return state;
  }
}
